import {constants} from '@newsela/angelou';
import {css} from 'emotion';

import fonts from 'static/three-oh/src/modules/utils/fonts';
const {colors: {ui}} = constants;

const suggestionContainer = css`
  list-style-type: none;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  cursor: pointer;
  font-size: ${fonts.sizes.m};

  display: flex;
  align-items: center;
  grid-gap: 16px;
  line-height: 25px;
  padding: .75em;
  color: ${ui.greyDark['500']};

  &:focus {
    background: rgba(194, 219, 254, 0.29);
    outline: none;
    border-radius: 4px;
  }
`;

const suggestionText = css`
  margin: 0;
`;

export const suggestionIconContainer = css`
  display: flex;
  justify-content: center;
  width: 24px;
`;

export const categoryLabel = css`
  font-size: 14px;
  color: ${ui.grey[700]};
`;

export default {
  suggestionContainer,
  suggestionText,
  suggestionIconContainer,
  categoryLabel
};
